import React, { useState, useCallback, useEffect } from "react";
import { useMutation } from "react-query";
import Axios from "axios";
import {
    antdAsyncMessageError,
    antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Switch, Select, Modal } from "antd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import XMLEditor from "../XMLEditor";
import debounce from 'lodash/debounce';
import { IconImport } from "../../../../../components/Layout/Icons";
import { Upload } from 'antd';
import Treeselect from "../../../../../components/common/Treeselect";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import FilterCombinations from "./FilterCombinations";



const LOOP_TAGS = {
    PRODUCT: {
        START: '[START_PRODUCT_LOOP]',
        END: '[END_PRODUCT_LOOP]',
    },
    CATEGORY: {
        START: '[START_CATEGORY_LOOP]',
        END: '[END_CATEGORY_LOOP]',
    }
};

const { confirm } = Modal;


const SelectWithConfirm = ({
    value,
    onChange,
    confirmClear = false,
    ...props
}) => {
    const handleChange = (newValue) => {
        if (confirmClear &&
            value?.length > 0 &&
            (!newValue || newValue.length === 0)) {

            confirm({
                title: "Are you sure?",
                icon: <ExclamationCircleOutlined className="text-primary" />,
                content: "You will not be able to undo this action",
                onOk() {
                    onChange(newValue);
                },
                onCancel() {
                    console.log("Clear canceled");
                },
            });
        } else {
            onChange(newValue);
        }
    };

    return (
        <Select
            {...props}
            value={value}
            onChange={handleChange}
            allowClear={confirmClear}
        />
    );
};

const ModalXMLFeedGeneration = ({ onClose, modalOpt }) => {
    const [form] = Form.useForm();
    const [brandsOptions, setBrandsOptions] = React.useState([]);
    const [suppliersOptions, setSuppliersOptions] = React.useState([]);
    const [productsOptions, setProductsOptions] = React.useState([]);
    const [categoriesOptions, setCategoriesOptions] = React.useState([]);
    const [orderShopOptions, setOrderShopOptions] = React.useState([]);
    const [orderShopValue, setOrderShopValue] = React.useState([]);
    const [categoriesIncludeValue, setCategoriesIncludeValue] = React.useState([]);
    //console.log("categoriesIncludeValue: ", categoriesIncludeValue);
    const [categoriesExcludeValue, setCategoriesExcludeValue] = React.useState([]);
    const [brandsIncludeValue, setBrandsIncludeValue] = React.useState([]);
    const [brandsExcludeValue, setBrandsExcludeValue] = React.useState([]);
    const [suppliersIncludeValue, setSuppliersIncludeValue] = React.useState([]);
    const [suppliersExcludeValue, setSuppliersExcludeValue] = React.useState([]);
    const [productsIncludeValue, setProductsIncludeValue] = React.useState([]);
    const [productsExcludeValue, setProductsExcludeValue] = React.useState([]);
    const [selectedCategoriesInclude, setSelectedCategoriesInclude] = useState([]);
    const [selectedCategoriesExclude, setSelectedCategoriesExclude] = useState([]);
    const [categoryTreeOptions, setCategoryTreeOptions] = useState([]);
    //console.log("categoryTreeOptions: ", categoryTreeOptions);
    const [active, setActive] = useState(false);
    const [csv, setCsv] = useState(false);
    const [marketplace, setMarketplace] = useState(false);
    const [inWarehouseProducts, setInWarehouseProducts] = useState(false);
    const [filterCombinations, setFilterCombinations] = useState([]);
    const [tags, setTags] = React.useState([]);
    const xmlEditorRef = React.useRef(null);
    const [xmlContent, setXmlContent] = React.useState(
        `<?xml version="1.0" encoding="UTF-8"?>
            <root>
                <item>Sample XML</item>
            </root>
        `
    );
    const tagStyle = {
        display: 'inline-block',
        padding: '6px 12px',
        margin: '4px',
        backgroundColor: '#f5f5f5',
        border: '1px solid #e8e8e8',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'all 0.3s',
    };

    const convertToTreeData = (flatData) => {
        const itemMap = {};
        flatData.forEach(item => {
            itemMap[item.id] = {
                name: item.name,
                value: item.id,
                children: []
            };
        });

        const treeData = [];

        flatData.forEach(item => {
            if (item.parent_id !== null && itemMap[item.parent_id]) {
                itemMap[item.parent_id].children.push(itemMap[item.id]);
            } else {
                treeData.push(itemMap[item.id]);
            }
        });

        // Assign fake IDs to parent nodes and insert duplicates with real IDs as their first child
        const modifyParentNodes = (node) => {
            if (node.children && node.children.length > 0) {
                const parentAsChild = {
                    name: `${node.name}`,
                    value: node.value,
                    isParentCopy: true
                };

                const realId = node.value;
                node.value = `00_${realId}`;

                node.children.unshift(parentAsChild);

                for (let i = 1; i < node.children.length; i++) {
                    modifyParentNodes(node.children[i]);
                }
            }

            return node;
        };

        const processedTreeData = treeData.map(modifyParentNodes);

        return processedTreeData;
    };


    React.useEffect(() => {
        if (modalOpt.type === "edit_xml_feed") {

            const fetchInitialData = async () => {
                const { data } = await Axios.get(`/api/v1/feeds/${modalOpt.record_id}`);
                const feed = data;
                try {
                    if (feed.included_brand_ids?.length) {
                        const brandParamsIn = feed.included_brand_ids
                            .map(id => `q[id_in][]=${id}`)
                            .join('&');
                        const { data: brandDataIn } = await Axios.get(
                            `/api/v1/brands?${brandParamsIn}`
                        );
                        setBrandsIncludeValue(
                            brandDataIn.map((b) => ({ label: b.title, value: b.id }))
                        );
                    } else {
                        setBrandsIncludeValue([]);
                    }

                    if (feed.excluded_brand_ids?.length) {
                        const brandParamsEx = feed.excluded_brand_ids
                            .map(id => `q[id_in][]=${id}`)
                            .join('&');
                        const { data: brandDataEx } = await Axios.get(
                            `/api/v1/brands?${brandParamsEx}`
                        );
                        setBrandsExcludeValue(
                            brandDataEx.map((b) => ({ label: b.title, value: b.id }))
                        );
                    } else {
                        setBrandsExcludeValue([]);
                    }

                    if (feed.included_supplier_ids?.length) {
                        const supplierParamsIn = feed.included_supplier_ids
                            .map(id => `q[id_in][]=${id}`)
                            .join('&');
                        const { data: supplierDataIn } = await Axios.get(
                            `/api/v1/suppliers/all?${supplierParamsIn}`
                        );
                        setSuppliersIncludeValue(
                            supplierDataIn.data?.map((b) => ({ label: b.title, value: b.id }))
                        );
                    } else {
                        setSuppliersIncludeValue([]);
                    }

                    if (feed.excluded_supplier_ids?.length) {
                        const supplierParamsEx = feed.excluded_supplier_ids
                            .map(id => `q[id_in][]=${id}`)
                            .join('&');
                        const { data: supplierDataEx } = await Axios.get(
                            `/api/v1/suppliers/all?${supplierParamsEx}`
                        );
                        setSuppliersExcludeValue(
                            supplierDataEx.data?.map((b) => ({ label: b.title, value: b.id }))
                        );
                    } else {
                        setSuppliersExcludeValue([]);
                    }

                    if (feed.included_category_ids?.length) {
                        const params = {
                            q: {
                                id_in: feed.included_category_ids
                            },
                            page: 1,
                            per_page: 9999999
                        };
                        const { data: categoriesIn } = await Axios.post(
                            `/api/v1/categories/simple_list`,
                            params
                        );
                        setCategoriesIncludeValue(
                            categoriesIn.map((c) => ({ label: c.name, value: c.id }))
                        );
                        setSelectedCategoriesInclude(feed.included_category_ids);
                    } else {
                        setCategoriesIncludeValue([]);
                    }

                    if (feed.excluded_category_ids?.length) {
                        const categoryParamsEx = {
                            q: {
                                id_in: feed.excluded_category_ids
                            },
                            page: 1,
                            per_page: 9999999
                        };
                        const { data: categoriesEx } = await Axios.post(
                            `/api/v1/categories/simple_list`,
                            categoryParamsEx
                        );
                        setCategoriesExcludeValue(
                            categoriesEx.map((c) => ({ label: c.name, value: c.id }))
                        );
                        setSelectedCategoriesExclude(feed.excluded_category_ids);
                    } else {
                        setCategoriesExcludeValue([]);
                    }

                    if (feed.included_product_ids?.length) {
                        const productParamsIn = {
                            q: {
                                id_in: feed.included_product_ids
                            },
                            page: 1,
                            per_page: 9999999
                        };
                        const { data: productsIn } = await Axios.post(
                            `/api/v1/products/simple_list`,
                            productParamsIn
                        );
                        const mappedIn = productsIn.data?.map((p) => ({ label: p.title, value: p.id })) || [];
                        setProductsIncludeValue(mappedIn);
                    } else {
                        setProductsIncludeValue([]);
                    }

                    if (feed.excluded_product_ids?.length) {
                        const productParamsExcl = {
                            q: {
                                id_in: feed.excluded_product_ids
                            },
                            page: 1,
                            per_page: 9999999
                        };
                        const { data: productsEx } = await Axios.post(
                            `/api/v1/products/simple_list`,
                            productParamsExcl
                        );
                        const mappedEx = productsEx.data?.map((p) => ({ label: p.title, value: p.id })) || [];
                        setProductsExcludeValue(mappedEx);
                    } else {
                        setProductsExcludeValue([]);
                    }

                    setActive(feed.active);
                    setCsv(feed.csv);
                    setMarketplace(feed.marketplace);
                    setInWarehouseProducts(feed.in_warehouse_products);
                    setOrderShopValue(feed.order_shop_id);
                    setXmlContent(feed.snippet);

                    if (feed.combinations?.length > 0) {
                        const loadedCombinations = await Promise.all(
                            feed.combinations.map(async (combo) => {
                                const result = {
                                    id: combo.id,
                                    categories: [],
                                    brands: [],
                                    suppliers: [],
                                    filter_type: combo.exclude ? "exclude" : "include",
                                };
                                try {
                                    if (combo.category_ids?.length > 0) {
                                        const { data: cData } = await Axios.post(`/api/v1/categories/simple_list`, {
                                            q: { id_in: combo.category_ids }, page: 1, per_page: 9999999
                                        });
                                        result.categories = (cData || []).map(c => ({ label: c.name, value: c.id }));
                                    }
                                    if (combo.brand_ids?.length > 0) {
                                        const brandParams = combo.brand_ids.map(id => `q[id_in][]=${id}`).join('&');
                                        const { data: bData } = await Axios.get(`/api/v1/brands?${brandParams}`);
                                        result.brands = bData.map(b => ({ label: b.title, value: b.id }));
                                    }
                                    if (combo.supplier_ids?.length > 0) {
                                        const supplierParams = combo.supplier_ids.map(id => `q[id_in][]=${id}`).join('&');
                                        const { data: sData } = await Axios.get(`/api/v1/suppliers/all?${supplierParams}`);
                                        result.suppliers = (sData.data || []).map(s => ({ label: s.title || s.name, value: s.id }));
                                    }
                                } catch (e) {
                                    console.error('Error loading filter combination:', e);
                                }
                                return result;
                            })
                        );
                        setFilterCombinations(loadedCombinations);
                    }

                    form.setFieldsValue({
                        title: feed.title,
                        url: feed.url,
                        csv_delimeter: feed.csv_delimeter,
                        order_shop: feed.order_shop_id,
                    });

                } catch (err) {
                    console.error(err);
                }
            };

            fetchInitialData();
        }
    }, [modalOpt, form]);

    React.useEffect(() => {
        fetchFeedSettings();
        fetchFeedOrderShops();
    }, []);

    const uploadProps = (setProductIds, type = 'include') => ({
        name: 'file',
        action: '/api/v1/feeds/product_ids?type=' + type + "&feed_id=" + modalOpt.record_id,
        accept: '.xlsx',
        showUploadList: false,
        onChange(info) {
            console.log(info);
            if (info.file.status === 'uploading') {
                return;
            }
            if (info.file.status === 'done') {
                const productIds = info.file.response;
                console.log(info.file.response);
                const fetchProductDetails = async () => {
                    try {
                        const params = {
                            q: {
                                id_in: productIds
                            },
                            page: 1,
                            per_page: 9999999
                        };
                        const { data: { data: products } } = await Axios.post(`/api/v1/products/simple_list`, params);

                        const formattedProducts = products.map(product => ({
                            label: product.title,
                            value: product.id
                        }));

                        setProductIds(formattedProducts);
                        antdAsyncMessageSuccess({ text: "Products imported successfully", key: "xlsx-import" });
                    } catch (error) {
                        console.error('Error fetching product details:', error);
                        const fallbackFormat = productIds.map(id => ({
                            label: `Product ${id}`,
                            value: id
                        }));
                        setProductIds(fallbackFormat);
                        antdAsyncMessageSuccess({ text: "Products imported with IDs only", key: "xlsx-import" });
                    }
                };

                fetchProductDetails();
                antdAsyncMessageSuccess({ text: "Products imported successfully", key: "xlsx-import" });
            } else if (info.file.status === 'error') {
                antdAsyncMessageError({ text: "Failed to import products", key: "xlsx-import" });
            }
        },

    });

    const fetchCategoriesOptions = async (category) => {
        const { data } = await Axios.post(
            `/api/v1/categories/simple_list`,
            {
                page: 1,
                per_page: 9999999
            }
        );
        const options = data.map((item) => ({ label: item.name, value: item.id }));
        const categoriesTreeData = convertToTreeData(data);
        setCategoryTreeOptions(categoriesTreeData);
        setCategoriesOptions(() => options);
    };

    const fetchBrandsOptions = async (brand) => {
        const { data } = await Axios.get(
            `/api/v1/brands?page=1&per_page=30&q[title_i_cont_any]=${brand}`
        );
        console.log("fetchBrandsOptions: ", data);
        const options = data.map((item) => ({ label: item.title, value: item.id }));
        setBrandsOptions(options);
    };

    const fetchSuppliersOptions = async (supplier) => {
        const { data } = await Axios.get(
            `/api/v1/suppliers/all?page=1&per_page=30&q[title_or_name_i_cont_any]=${supplier}`
        );
        console.log("fetchSuppliersOptions: ", data);
        const options = data.data.map((item) => ({ label: (item.title || item.name), value: item.id }));
        setSuppliersOptions(options);
    };

    const fetchProductsOptions = async (product_code) => {
        const { data } = await Axios.get(
            `/api/v1/products?page=1&per_page=20&q[identifier_eq]=${product_code}`
        );
        const options = data.data.map((item) => ({ label: item.title, value: item.id }));
        setProductsOptions(() => options);
    };

    const fetchFeedSettings = async () => {
        const { data } = await Axios.get('/api/v1/feeds/tags');
        const productTags = data.product_tags.map((tag) => ({ title: tag, value: tag }));
        const settingTags = data.setting_tags.map((tag) => ({ title: tag, value: tag }));
        setTags([...productTags, ...settingTags]);
    };

    const fetchFeedOrderShops = async () => {
        const { data } = await Axios.get(
            `/api/v1/order_shops`
        );
        console.log("fetchFeedOrderShops: ", data);
        const options = data.shops.map((item) => ({ label: item.label, value: item.value }));
        console.log("fetchFeedOrderShops: ", options);
        setOrderShopOptions(options);
    };

    const mutationPOST = useMutation({
        mutationFn: (feed) => {
            return Axios.post(`/api/v1/feeds`, {
                feed: {
                    title: feed.title,
                    active: feed.active,
                    marketplace: feed.marketplace,
                    csv: feed.csv,
                    in_warehouse_products: inWarehouseProducts,
                    url: feed.url,
                    csv_delimeter: feed.csv_delimeter,
                    snippet: xmlContent,
                    excluded_brand_ids: brandsExcludeValue?.map(item => item.value),
                    included_brand_ids: brandsIncludeValue?.map(item => item.value),
                    excluded_supplier_ids: suppliersExcludeValue?.map(item => item.value),
                    included_supplier_ids: suppliersIncludeValue?.map(item => item.value),
                    excluded_product_ids: productsExcludeValue?.map(item => item.value),
                    included_product_ids: productsIncludeValue?.map(item => item.value),
                    included_category_ids: categoriesIncludeValue?.map(item => item.value),
                    excluded_category_ids: categoriesExcludeValue?.map(item => item.value),
                    order_shop_id: orderShopValue,
                    starts_at: feed.starts_at,
                    feed_combinations_attributes: filterCombinations.map(combo => {
                        const attr = {
                            category_ids: combo.categories?.map(c => c.value) || [],
                            brand_ids: combo.brands?.map(b => b.value) || [],
                            supplier_ids: combo.suppliers?.map(s => s.value) || [],
                            exclude: combo.filter_type === "exclude",
                        };
                        if (combo.id) attr.id = combo.id;
                        if (combo._destroy) attr._destroy = 1;
                        return attr;
                    }),
                },
            }).then((res) => {
                onClose();
                antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
            }).catch((err) => {
                if (err?.response?.data?.message && typeof err.response.data.message === 'object') {
                    const parsedErrors = Object.entries(err.response.data.message).map(([field, messages]) => {
                        if (Array.isArray(messages)) {
                            return `${field}: ${messages.join(', ')}`;
                        } else {
                            return `${field}: ${messages}`;
                        }
                    });
                    antdAsyncMessageError({ text: parsedErrors.join('\n'), key: "default" });
                } else {
                    antdAsyncMessageError({ text: JSON.stringify(err?.response?.data?.message) || "Failed to update", key: "default" });
                }
            });
        },
    });

    const mutationPUT = useMutation({
        mutationFn: (feed) => {
            return Axios.put(`/api/v1/feeds/${modalOpt.record_id}`, {
                feed: {
                    title: feed.title,
                    active: feed.active,
                    marketplace: feed.marketplace,
                    csv: feed.csv,
                    in_warehouse_products: inWarehouseProducts,
                    url: feed.url,
                    csv_delimeter: feed.csv_delimeter,
                    snippet: xmlContent,
                    excluded_brand_ids: brandsExcludeValue?.map(item => item.value),
                    included_brand_ids: brandsIncludeValue?.map(item => item.value),
                    excluded_supplier_ids: suppliersExcludeValue?.map(item => item.value),
                    included_supplier_ids: suppliersIncludeValue?.map(item => item.value),
                    excluded_product_ids: productsExcludeValue?.map(item => item.value),
                    included_product_ids: productsIncludeValue?.map(item => item.value),
                    included_category_ids: categoriesIncludeValue?.map(item => item.value),
                    excluded_category_ids: categoriesExcludeValue?.map(item => item.value),
                    order_shop_id: orderShopValue,
                    starts_at: feed.starts_at,
                    feed_combinations_attributes: filterCombinations.map(combo => {
                        const attr = {
                            category_ids: combo.categories?.map(c => c.value) || [],
                            brand_ids: combo.brands?.map(b => b.value) || [],
                            supplier_ids: combo.suppliers?.map(s => s.value) || [],
                            exclude: combo.filter_type === "exclude",
                        };
                        if (combo.id) attr.id = combo.id;
                        if (combo._destroy) attr._destroy = 1;
                        return attr;
                    }),
                },
            }).then((res) => {
                onClose();
                antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
            }).catch((err) => {
                if (err?.response?.data?.message && typeof err.response.data.message === 'object') {
                    const parsedErrors = Object.entries(err.response.data.message).map(([field, messages]) => {
                        if (Array.isArray(messages)) {
                            return `${field}: ${messages.join(', ')}`;
                        } else {
                            return `${field}: ${messages}`;
                        }
                    });
                    antdAsyncMessageError({ text: parsedErrors.join('\n'), key: "default" });
                } else {
                    antdAsyncMessageError({ text: JSON.stringify(err?.response?.data?.message) || "Failed to update", key: "default" });
                }
            });
        }
    });

    const handleLoopTagClick = (loopType) => {
        const loopContent = {
            PRODUCT: `
    ${LOOP_TAGS.PRODUCT.START}
    <product>
    
    </product>
    ${LOOP_TAGS.PRODUCT.END}`,
            CATEGORY: `
    ${LOOP_TAGS.CATEGORY.START}
    <category>
    
    </category>
    ${LOOP_TAGS.CATEGORY.END}`
        };

        if (xmlEditorRef.current) {
            xmlEditorRef.current.insertTagAtCursor(loopContent[loopType]);
            xmlEditorRef.current.focusEditor();
        } else {
            setXmlContent((prev) => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(prev, "text/xml");
                const rootElement = xmlDoc.querySelector("root");

                if (!rootElement) {
                    return `<?xml version="1.0" encoding="UTF-8"?>
    <root>
        ${loopContent[loopType]}
    </root>`;
                } else {
                    const insertPoint = prev.lastIndexOf("</root>");
                    return prev.slice(0, insertPoint) + loopContent[loopType] + "\n" + prev.slice(insertPoint);
                }
            });
        }
    };

    const handleTagClick = (tag, value) => {
        if (tag.startsWith('LOOP_')) {
            handleLoopTagClick(tag.replace('LOOP_', ''));
            return;
        }

        if (xmlEditorRef.current) {
            xmlEditorRef.current.insertTagAtCursor(`[${value}]`);
            xmlEditorRef.current.focusEditor();
        } else {
            setXmlContent((prev) => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(prev, "text/xml");
                const rootElement = xmlDoc.querySelector('root');

                if (!rootElement) {
                    return `<?xml version="1.0" encoding="UTF-8"?>
    <root>
        [${value}]
    </root>`;
                } else {
                    const newTag = `\n[${value}]`;
                    const insertPoint = prev.lastIndexOf('</root>');
                    return prev.slice(0, insertPoint) + newTag + '\n' + prev.slice(insertPoint);
                }
            });
        }
    };

    const debouncedFetchCategories = useCallback(
        debounce((search) => fetchCategoriesOptions(search), 500),
        []
    );

    const debouncedFetchBrands = useCallback(
        debounce((search) => fetchBrandsOptions(search), 500),
        []
    );

    const debouncedFetchSuppliers = useCallback(
        debounce((search) => fetchSuppliersOptions(search), 500),
        []
    );

    const debouncedFetchProducts = useCallback(
        debounce((search) => fetchProductsOptions(search), 500),
        []
    );

    useEffect(() => {
        fetchCategoriesOptions();
    }, []);

    return (
        <ModalSpecial
            style={{ width: 570 }}
            text={
                <span className="font-bold text-xl text-black">
                    {modalOpt.type === "edit_xml_feed" ? "Edit" : "New"} XML feed generation
                </span>
            }
            onClose={onClose}
        >
            <Form
                form={form}
                layout="vertical"
                name="basic"
                onFinish={(values) => {
                    console.log("On finish:", values);
                    if (modalOpt.type === "edit_xml_feed") {
                        mutationPUT.mutate(values);
                    } else {
                        mutationPOST.mutate(values);
                    }
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="Title"
                    name="title"
                    style={{ marginBottom: 0 }}
                >
                    <Input placeholder="Type in" />
                </Form.Item>
                <Form.Item label="Order Shop" name="order_shop" style={{ marginBottom: 0 }}>
                    <Select
                        placeholder="Select"
                        value={orderShopValue}
                        onChange={(value) => setOrderShopValue(value)}
                        options={orderShopOptions}
                    />
                </Form.Item>
                <Form.Item
                    label="Categories"
                    name="categories"
                    style={{ marginBottom: 0 }}
                >
                    <div
                        className="p-2"
                        style={{
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #EFEFEF",
                            borderRadius: 1,
                        }}
                    >
                        <div className="text-xs">Include</div>
                        <Treeselect
                            options={categoryTreeOptions}
                            value={selectedCategoriesInclude || []}
                            onChange={(values) => {
                                setSelectedCategoriesInclude(values);
                                const formattedCategories = values.map(value => {
                                    const id = typeof value === 'string' && value.startsWith('00_') ?
                                        parseInt(value.substring(3)) : value;
                                    const category = categoriesOptions.find(cat => cat.value === id);
                                    return {
                                        label: category?.label || `Category ${id}`,
                                        value: id
                                    };
                                });
                                setCategoriesIncludeValue(formattedCategories);
                            }}
                            placeholder="Select categories..."
                            multiSelect={true}
                            confirmClear={true}
                            showStrategy="SHOW_ALL"
                        />

                        <div className="text-xs">Exclude</div>
                        <Treeselect
                            options={categoryTreeOptions}
                            value={selectedCategoriesExclude || []}
                            onChange={(values) => {
                                setSelectedCategoriesExclude(values);
                                const formattedCategories = values.map(value => {
                                    const id = typeof value === 'string' && value.startsWith('00_') ?
                                        parseInt(value.substring(3)) : value;
                                    const category = categoriesOptions.find(cat => cat.value === id);
                                    return {
                                        label: category?.label || `Category ${id}`,
                                        value: id
                                    };
                                });
                                setCategoriesExcludeValue(formattedCategories);
                            }}
                            placeholder="Select categories..."
                            multiSelect={true}
                            confirmClear={true}
                            showStrategy="SHOW_ALL"
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    label="Products"
                    name="products"
                    style={{ marginBottom: 0 }}
                >
                    <div
                        className="p-2"
                        style={{
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #EFEFEF",
                            borderRadius: 1,
                        }}
                    >
                        <div className="d-flex align-items-center mb-3" style={{ gap: 8 }}>
                            <span>Only products in warehouse</span>
                            <Switch checked={inWarehouseProducts} onClick={() => setInWarehouseProducts((prev) => !prev)} />
                        </div>
                        <div className="text-xs">Include</div>
                        <SelectWithConfirm
                            mode="multiple"
                            options={productsOptions}
                            value={productsIncludeValue}
                            dropdownMatchSelectWidth={false}
                            labelInValue
                            showSearch
                            filterOption={false}
                            onChange={(value) => setProductsIncludeValue(value)}
                            onSearch={debouncedFetchProducts}
                            confirmClear={true}
                        />
                        <Upload {...uploadProps(setProductsIncludeValue, 'include')}>
                            <Button
                                icon={<IconImport />}
                                size="small"
                                type="link"
                                className="text-primary p-0"
                            >
                                Import XLSX (Include)
                            </Button>
                        </Upload>
                        <div className="text-xs">Exclude</div>
                        <SelectWithConfirm
                            mode="multiple"
                            options={productsOptions}
                            value={productsExcludeValue}
                            dropdownMatchSelectWidth={false}
                            labelInValue
                            showSearch
                            filterOption={false}
                            onChange={(value) => setProductsExcludeValue(value)}
                            onSearch={debouncedFetchProducts}
                            confirmClear={true}
                        />
                        <Upload {...uploadProps(setProductsExcludeValue, 'exclude')}>
                            <Button
                                icon={<IconImport />}
                                size="small"
                                type="link"
                                className="text-primary p-0"
                            >
                                Import XLSX (Exclude)
                            </Button>
                        </Upload>
                    </div>
                </Form.Item>
                <Form.Item
                    label="Brands"
                    name="brands"
                    style={{ marginBottom: 0 }}
                >
                    <div
                        className="p-2"
                        style={{
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #EFEFEF",
                            borderRadius: 1,
                        }}
                    >
                        <div className="text-xs">Include</div>
                        <SelectWithConfirm
                            mode="multiple"
                            options={brandsOptions}
                            value={brandsIncludeValue}
                            dropdownMatchSelectWidth={false}
                            labelInValue
                            showSearch
                            filterOption={false}
                            onChange={(value) => setBrandsIncludeValue(value)}
                            onSearch={debouncedFetchBrands}
                            confirmClear={true}
                        />
                        <div className="text-xs">Exclude</div>
                        <SelectWithConfirm
                            mode="multiple"
                            options={brandsOptions}
                            value={brandsExcludeValue}
                            dropdownMatchSelectWidth={false}
                            labelInValue
                            showSearch
                            filterOption={false}
                            onChange={(value) => setBrandsExcludeValue(value)}
                            onSearch={debouncedFetchBrands}
                            confirmClear={true}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    label="Suppliers"
                    name="suppliers"
                    style={{ marginBottom: 0 }}
                >
                    <div
                        className="p-2"
                        style={{
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #EFEFEF",
                            borderRadius: 1,
                        }}
                    >
                        <div className="text-xs">Include</div>
                        <SelectWithConfirm
                            mode="multiple"
                            options={suppliersOptions}
                            value={suppliersIncludeValue}
                            dropdownMatchSelectWidth={false}
                            labelInValue
                            showSearch
                            filterOption={false}
                            onChange={(value) => setSuppliersIncludeValue(value)}
                            onSearch={debouncedFetchSuppliers}
                            confirmClear={true}
                        />
                        <div className="text-xs">Exclude</div>
                        <SelectWithConfirm
                            mode="multiple"
                            options={suppliersOptions}
                            value={suppliersExcludeValue}
                            dropdownMatchSelectWidth={false}
                            labelInValue
                            showSearch
                            filterOption={false}
                            onChange={(value) => setSuppliersExcludeValue(value)}
                            onSearch={debouncedFetchSuppliers}
                            confirmClear={true}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    label="Filter combinations"
                    name="filter_combinations"
                    style={{ marginBottom: 0 }}
                >
                    <FilterCombinations
                        combinations={filterCombinations}
                        setCombinations={setFilterCombinations}
                        categoryTreeOptions={categoryTreeOptions}
                        categoriesOptions={categoriesOptions}
                        brandsOptions={brandsOptions}
                        suppliersOptions={suppliersOptions}
                        onSearchBrands={debouncedFetchBrands}
                        onSearchSuppliers={debouncedFetchSuppliers}
                    />
                </Form.Item>
                <Form.Item
                    label="XML snippet"
                    name="xml_snippet"
                    style={{ marginBottom: 0 }}
                >
                    <div>
                        <XMLEditor
                            ref={xmlEditorRef}
                            value={xmlContent}
                            onChange={setXmlContent}
                        />
                    </div>
                    <button type="button" className="text-primary initial-button mt-1 mb-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                        >
                            <path
                                d="M2.33398 4.37508V1.75008C2.33398 1.59537 2.39544 1.447 2.50484 1.3376C2.61424 1.22821 2.76261 1.16675 2.91732 1.16675H11.084C11.2387 1.16675 11.3871 1.22821 11.4965 1.3376C11.6059 1.447 11.6673 1.59537 11.6673 1.75008V12.2501C11.6673 12.4048 11.6059 12.5532 11.4965 12.6626C11.3871 12.772 11.2387 12.8334 11.084 12.8334H2.91732C2.76261 12.8334 2.61424 12.772 2.50484 12.6626C2.39544 12.5532 2.33398 12.4048 2.33398 12.2501V9.62508"
                                stroke="#03B0F7"
                                strokeWidth="1.16667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M9.04199 4.37524H9.91699M8.16699 6.70858H9.91699M8.16699 9.04191H9.91699"
                                stroke="#03B0F7"
                                strokeWidth="1.16667"
                                strokeLinecap="round"
                            />
                            <path
                                d="M2.91699 6.12524L4.66699 7.87524M4.66699 6.12524L2.91699 7.87524M1.16699 4.37524H6.41699V9.62524H1.16699V4.37524Z"
                                stroke="#03B0F7"
                                strokeWidth="1.16667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <a href="/files/xml_feed_import_file_sample.xlsx" download>
                            <span className="text-decoration-underline pl-1">
                                Download XSLX sample
                            </span>
                        </a>
                    </button>
                </Form.Item>
                <Form.Item
                    label="Available tags"
                    name="available_tags"
                    style={{ marginBottom: 0 }}
                >
                    <div className="flex flex-wrap gap-2">
                        {tags.map((tag, index) => (
                            <div
                                key={tag.title + tag.value + index}
                                onClick={() => handleTagClick(tag.title, tag.value)}
                                style={tagStyle}
                                className="hover:bg-gray-200"
                            >
                                {tag.title}
                            </div>
                        ))}
                        <div
                            onClick={() => handleTagClick("LOOP_PRODUCT")}
                            style={tagStyle}
                            className="hover:bg-gray-200"
                        >
                            LOOP PRODUCT
                        </div>
                        <div
                            onClick={() => handleTagClick("LOOP_CATEGORY")}
                            style={tagStyle}
                            className="hover:bg-gray-200"
                        >
                            LOOP CATEGORY
                        </div>
                    </div>
                </Form.Item>
                <Form.Item
                    label="URL"
                    name="url"
                    extra="If left empty, system will generate random URL"
                >
                    <Input prefix="feeds.bgbx.eu/" placeholder="Type in" />
                </Form.Item>
                {/* <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Starts at" name="starts_at">
                            <DatePicker showTime placeholder="Select date and time" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Repeat every" name="repeat_every">
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Select
                                        options={[
                                            { label: "Hour", value: "Hour" },
                                            { label: "Day", value: "Day" },
                                            { label: "Month", value: "Month" },
                                        ]}
                                        onChange={(value) => setRepeatPeriod(value)}
                                        value={repeatPeriod}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        options={
                                            repeatPeriod === "Day"
                                                ? generateOptions(30)
                                                : repeatPeriod === "Hour"
                                                    ? generateOptions(24)
                                                    : generateOptions(12)
                                        }
                                    />
                                </Col>
                            </Row>
                        </Form.Item>
                    </Col>
                </Row> */}
                <Form.Item
                    label="Status"
                    name="active"
                    className="w-50 d-inline-block"
                >
                    <Switch checked={active} onClick={() => setActive((prev) => !prev)} />
                </Form.Item>
                <Form.Item
                    label="Marketplace"
                    name="marketplace"
                    className="w-50 d-inline-block"
                >
                    <Switch checked={marketplace} onClick={() => setMarketplace((prev) => !prev)} />
                </Form.Item>
                <Form.Item
                    label="Generate in CSV"
                    name="csv"
                    className="w-50 d-inline-block"
                >
                    <Switch checked={csv} onClick={() => setCsv((prev) => !prev)} />
                </Form.Item>
                <Form.Item
                    label="CSV delimeter"
                    name="csv_delimeter"
                    className="w-50 d-inline-block"
                >
                    <Input placeholder="Type in" />
                </Form.Item>
                <Form.Item>
                    <Button
                        className="w-100"
                        type="primary"
                        htmlType="submit"
                        loading={mutationPOST.isLoading || mutationPUT.isLoading}
                    >
                        {modalOpt.type === "edit_xml_feed" ? "Update" : "Add"}
                    </Button>
                </Form.Item>
            </Form>
        </ModalSpecial>
    );
};

export default ModalXMLFeedGeneration;
